import React, { useEffect, useState } from "react";
import Input from "../Input";
import Button from "../Button";
import DateInput from "../dateInput";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import SelectInput from "../selectInput";
import {
  AddPurchaseTransaction,
  GetPurchaseById,
} from "../../redux/Transaction/action";
import { getPayment, getPaymentById } from "../../redux/payment/action";
import { getVendors } from "../../redux/vendors/action";
import { validatePurchaseForm } from "../../validation/TransactionValidation";
import Loader from "../loader";

const TransactionPurchaseForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    date: null,
    title: "",
    vendorselection: "",
    nonvatamount: Number,
    vatamount: Number,
    // amounttype: "",
    paymentmethod: "",
    description: "",
    status: false,
    pendingpayment: false,
    totalamount: Number,
  });
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: "",
  });

  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );
  const getVendorsData = useSelector(
    (state) => state?.Vendors?.getVendors?.data
  );
  const Payment = useSelector((state) => state?.Payment?.getPaymentId?.data);

  const paymentOption = getPaymentData?.map((e) => {
    return {
      lable: e?.paymentmethod,
      value: e?._id,
    };
  });
  const vendorOption = getVendorsData?.map((e) => {
    return {
      lable: e?.name,
      value: e?._id,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = {
      ...data,
      [name]: value,
    };

    // Update state with the new input value
    setData(updatedData);

    const updatedTotalAmount =
      Number(updatedData.nonvatamount) + Number(updatedData.vatamount);
    setTotalAmount(
      Number(updatedData.nonvatamount) && Number(updatedData.vatamount)
        ? updatedTotalAmount
        : Number(updatedData.nonvatamount) || Number(updatedData.vatamount)
    );

    if (isSubmit) {
      const updatedErrors = validatePurchaseForm({
        ...data,
        [name]: value,
      });
      setErrors(updatedErrors);
    }
  };

  const handleDateChange = (date, dateString) => {
    setData((prevData) => ({
      ...prevData,
      date: dateString,
    }));
    if (isSubmit) {
      const updatedErrors = validatePurchaseForm({
        ...data,
        date: dateString,
      });
      setErrors(updatedErrors);
    }
  };

  const handleCheckboxChange = (e) => {
    setCheckboxChecked(e.target.checked); // Update checkbox state
  };

  const resetForm = () => {
    setData({
      date: null,
      title: "",
      vendorselection: "",
      nonvatamount: Number,
      vatamount: Number,
      paymentmethod: "",
      description: "",
      status: false,
      pendingpayment: false,
      totalamount: setTotalAmount(0),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const validationErrors = validatePurchaseForm(data, Payment);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        let obj = {
          date: data?.date,
          title: data?.title,
          vendorselection: data?.vendorselection,
          nonvatamount: Number(data?.nonvatamount),
          vatamount: Number(data?.vatamount),
          paymentmethod: data?.paymentmethod,
          description: data?.description,
          status: false,
          pendingpayment: checkboxChecked,
          totalamount: totalAmount,
        };

        await dispatch(AddPurchaseTransaction(obj)).then((res) => {
          if (res?.status === 200) {
            resetForm();
            setLoading(false);
            navigate("/home/dashboard/purchase");
          } else if (res?.status === 401) {
            setLoading(false);
            navigate("/");
          }
        });
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
        return error;
      }
    }
  };

  useEffect(() => {
    const fetchPaymentById = async () => {
      if (data?.paymentmethod) {
        await dispatch(getPaymentById(data?.paymentmethod, dispatch));
      }
    };

    fetchPaymentById();

    // No cleanup needed, but if you had one, it should return a function like this:
    return () => {
      // Clean up code (if needed)
    };
  }, [data?.paymentmethod]);

  useEffect(() => {
    dispatch(
      getPayment({
        page: filter?.page,
        limit: filter?.limit,
        search: filter?.search,
      })
    );
    dispatch(
      getVendors({
        page: filter?.page,
        limit: filter?.limit,
        search: filter?.search,
      })
    );
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div className="text-base font-normal">
        <div className="grid grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 gap-x-6 gap-y-7 max-sm:gap-y-4">
          <div>
            <DateInput
              onChange={handleDateChange}
              value={data.date ? dayjs(data.date, "DD/MM/YYYY") : null}
              name={"date"}
            />
            {errors.date && <p className="text-red-500">{errors.date}</p>}
          </div>

          <div>
            <Input
              lableName={"Title"}
              inputType={"text"}
              onChange={handleChange}
              value={data?.title}
              name={"title"}
            />
            {errors.title && <p className="text-red-500">{errors.title}</p>}
          </div>

          <div>
            <SelectInput
              lableName={"Vendor Selection"}
              option={vendorOption}
              onChange={handleChange}
              value={data?.vendorselection}
              name={"vendorselection"}
            />
            {errors.vendorselection && (
              <p className="text-red-500">{errors.vendorselection}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"Non VAT Amount"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data?.nonvatamount}
              name={"nonvatamount"}
            />
            {errors.nonvatamount && (
              <p className="text-red-500">{errors.nonvatamount}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"Vat amount"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data?.vatamount}
              name={"vatamount"}
            />
            {errors.vatamount && (
              <p className="text-red-500">{errors.vatamount}</p>
            )}
          </div>

          <div>
            <SelectInput
              lableName={"Payment Method"}
              option={paymentOption}
              onChange={handleChange}
              value={data?.paymentmethod}
              name={"paymentmethod"}
            />
            {errors.paymentmethod && (
              <p className="text-red-500">{errors.paymentmethod}</p>
            )}
          </div>

          <div>
            <Input
              textarea={true}
              lableName={"Description"}
              onChange={handleChange}
              value={data?.description}
              name={"description"}
            />
            {errors.description && (
              <p className="text-red-500">{errors.description}</p>
            )}
          </div>

          <div>
            <div className="flex flex-col gap-1">
              <label htmlFor="Pending Amount">Pending Amount</label>
              <div
                onClick={() => setCheckboxChecked(!checkboxChecked)}
                className="flex items-center h-[50px] border rounded-[10px] px-3 gap-2"
              >
                <input
                  className="border-none outline-none flex items-start"
                  type="checkbox"
                  checked={checkboxChecked}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="checkbox">Pending payment</label>
              </div>
            </div>
          </div>

          <div>
            <Input
              lableName={"Total Amount"}
              inputType={"number"}
              currency={true}
              value={totalAmount}
              name={"totalAmount"}
              disabled={true} // Disable the field to prevent user input
            />
            {errors.totalamount && (
              <p className="text-red-500">{errors.totalamount}</p>
            )}
          </div>
        </div>

        <div className="mt-12 max-sm:mt-8 flex justify-center items-center gap-x-7  max-sm:gap-x-4">
          <Button
            disabled={loading}
            type={"submit"}
            children={
              <div className="flex items-center">
                {loading && <Loader />}Save
              </div>
            }
            className={"bg-green hover:bg-darkgreen text-white"}
          />
          <Button
            disabled={loading}
            onClick={resetForm}
            children={"Cancel"}
            className={
              "border border-green hover:bg-gray-100 hover:border-darkgreen text-green hover:text-darkgreen"
            }
          />
        </div>
      </div>
    </form>
  );
};

export default TransactionPurchaseForm;
